import React, { Component } from 'react';
import { Breadcrumb } from 'antd';
import { withRouter, Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-flexbox-grid';
import './Tasks.css';
import TaskList from '../../components/TaskList';
import TabsState from '../../components/TabsState';
import Spinner, { spinnerOff, spinnerOn } from 'components/Spinner';

const RenderTasks = (props) => {
  if (props.taskList.tasks.length > 0) {
    return (
      <TaskList
        listTitle={props.assetName}
        preFormSignedFl={props.preFormSignedFl}
        assetDeleteFl={props.assetDeleteFl}
        onSignHandler={props.onSignEvent}
        onRequestSignatureHandler={props.onRequestSignEvent}
        onMarkNaHandler={props.onMarkNaEvent}
        onMarkTempHandler={props.onMarkTempEvent}
        onUndoHandler={props.onUndoEvent}
        tasks={props.taskList.tasks}
        projectStatus={props.projectStatus}
        bpid={props.bpid}
        projectData={props}
      />
    );
  } else {
    return (
      <div className='empty-table'>There are no tasks in this category.</div>
    );
  }
};

class Tasks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assets: this.props.assets,
      sections: [],
    };
    }
    
   

  render() {
    const { tasks, match, section, location, assetDetail } = this.props;

    const {
      assetName,
      preFormSignedFl,
      assetDeleteFl,
      onSignEvent,
      onRequestSignEvent,
      onMarkNaEvent,
      onMarkTempEvent,
      onUndoEvent,
      currentSection,
      ipsLocation,
    } = this.props;
    const isSection = Array.isArray(location.pathname.match(/allsections/g));
    const isIps = Array.isArray(location.pathname.match(/ipslocations/g));
    const projectId = match.params.projectId;
    const projectStatus = match.params.state;
    const filter = match.params.filter;

    const {
      assetGroup,
      assetType,
      bpid,
      workOrder,
      formName,
      preEnergizationDate,
      assetStatus,
      ipsLocation: ipsLocationPath,
      protectionCommApplied,
      mechanismType,
      ipsvalueChanged
    } = assetDetail;
        
      return (
         
        
      <Grid Grid id='task--container' fluid>
        <Grid Breadcrumb className='breadcrumb-item'>
          <Breadcrumb.Item>
            <Link
              to={`/${projectStatus}/${projectId}/assettasks/${filter}`}
              style={{ fontize: '30px' }}
            >
              {isSection === true && 'All Sections'}
              {isIps === true && 'IPS Locations'}
            </Link>
          </Breadcrumb.Item>
          {(section || ipsLocation) && (
            <Breadcrumb.Item>
              {isSection === true && (
                <Link
                  to={`/${projectStatus}/${projectId}/assettasks/${filter}/${section.id}`}
                >
                  {section.name}
                </Link>
              )}
              {isIps === true && (
                <Link
                  to={`/${projectStatus}/${projectId}/assettasks/${filter}/${ipsLocation.id}`}
                >
                  {ipsLocation.name}
                </Link>
              )}
            </Breadcrumb.Item>
          )}
          <Breadcrumb.Item>{assetName}</Breadcrumb.Item>
        </Grid>
        <Row>
          <Col xs={12} className='task--header'>
            {assetName}
          </Col>
        </Row>

        {assetName && (
          <Row className='detail-container'>
            <Col>
              <Row>
                <span className='detail-field'>Asset Group : </span>&nbsp;
                {assetGroup}{' '}
              </Row>
              <Row>
                <span className='detail-field'>Asset Type :</span>&nbsp;
                {assetType}{' '}
              </Row>
              <Row>
                <span className='detail-field'>IPS Location Path :</span>&nbsp;
                {ipsLocationPath}{' '}
              </Row>
              
            </Col>
            <Col className='center-field'>
              <Row>
                <span className='detail-field'>Install BPID :</span>&nbsp;{bpid}{' '}
              </Row>
              <Row>
                <span className='detail-field'>Install WO# :</span>&nbsp;
                {workOrder}{' '}
              </Row>
              {assetGroup !== null && assetGroup !== undefined &&  assetGroup == 'DSC' &&( 
                <Row>
                <span className='detail-field'> Mechanism Type :</span>&nbsp;
                {mechanismType ?? "[Blank]"}{' '}
              </Row>
                )
              }

            {assetGroup !== null && assetGroup !== undefined &&  assetGroup == 'REL' &&( 
                <Row>
                <span className='detail-field'>Protection Comm Applied :</span>&nbsp;
                {protectionCommApplied ?? "[Blank]"}{' '}
              </Row>
                )
                  }

              {ipsvalueChanged !== null &&(
                  <Row>
                <div>
                        
                    <i className="fa fa-info-circle" style={{color:'red', paddingRight: '3px'}}
                       aria-hidden="true"></i><i><b>{ipsvalueChanged} <br/></b></i>
                    </div>
                </Row>   
              )}
                
            </Col>
            <Col>
              <Row>
                <span className='detail-field'>Pre-E Form Assigned :</span>
                &nbsp;
                {formName}
              </Row>
              <Row>
                <span className='detail-field'>
                  Pre-E Form Energization Date :
                </span>
                &nbsp;
                { preEnergizationDate ? preEnergizationDate : 'Not Assigned'}
              </Row>
              <Row>
                <span className='detail-field'>IPS Asset Status :</span>&nbsp;
                {assetStatus}{' '}
              </Row>
            </Col>
          </Row>
            )}
        
           
        <Row>
          <Col xs={12} className='task--version--header'>
            <strong>Task Version #: </strong>
            {tasks[0].tasks[1]?.revisionNo
              ? 'Rev ' + tasks[0].tasks[1]?.revisionNo
              : 'N/A'}
          </Col>
        </Row>

        <Row style={{ height: '100% ' }}>
          <Col xs={12}>
            {tasks.length > 0 && (
              <TabsState
                routes={tasks.map((taskList) => {
                  return {
                    title: taskList.name,
                    component: () => (
                      <RenderTasks
                        assetName={assetName}
                        preFormSignedFl={preFormSignedFl}
                        assetDeleteFl={assetDeleteFl}
                        currentSection={currentSection}
                        ipsLocation={ipsLocation}
                        onSignEvent={onSignEvent}
                        onRequestSignEvent={onRequestSignEvent}
                        onMarkNaEvent={onMarkNaEvent}
                        onMarkTempEvent={onMarkTempEvent}
                        onUndoEvent={onUndoEvent}
                        taskList={taskList}
                        projectStatus={this.props.projectStatus}
                        bpid={bpid}
                        projectData={this.props}
                      />
                    ),
                  };
                })}
              />
            )}
          </Col>
        </Row>
              </Grid>
              
    );
  }
}

export default withRouter(Tasks);
